import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// --- Sélection de toutes les sections ---
const sections = document.querySelectorAll(
  ".start, .branches-wrapper, .moi, .homepage-projet, .autres, .contact"
);

sections.forEach((section) => {
  // --- Section branches spéciale ---
  if (section.classList.contains("branches-wrapper")) {
    const branches = gsap.utils.toArray(".branches");
    const titles = gsap.utils.toArray(".branches-titre");

    // Superposition des fonds et invisibilité des titres
    branches.forEach((branch, i) => {
      gsap.set(branch, { autoAlpha: i === 0 ? 1 : 0 });
    });
    titles.forEach((title) => gsap.set(title, { opacity: 0, y: 40 }));

    // Timeline globale pour le wrapper branches
    const tlBranches = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=" + branches.length * 150 + "%",
        pin: true,
        pinSpacing: true,
        scrub: 1.2,
      },
    });

    // Animation des titres et crossfade des fonds
    branches.forEach((branch, i) => {
      // Faire apparaître le titre
      if (titles[i]) {
        tlBranches.to(
          titles[i],
          { opacity: 1, y: 0, duration: 1, ease: "power2.out" },
          "+=0.5"
        );
      }

      // Crossfade vers le fond suivant
      if (branches[i + 1]) {
        tlBranches.to(
          branch,
          { autoAlpha: 0, duration: 0.8, ease: "power2.inOut" },
          "+=1"
        );
        tlBranches.to(branches[i + 1], { autoAlpha: 1, duration: 0.8 }, "<");
      }
    });
  }
  // --- Sections normales (start, moi, projets, autres, contact) ---
  else {
    const content = section.querySelector(
      ".start, .moi-content, .homepage-projet-content, .autres-title, .contact-content"
    );

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=200%",
        pin: true,
        pinSpacing: true,
        scrub: 1.6,
      },
    });

    // Petite pause avant animation
    tl.to({}, { duration: 0.35 });

    // Animation d'arrivée
    if (content) {
      tl.fromTo(
        content,
        { opacity: 0, y: 140, scale: 0.98 },
        { opacity: 1, y: 0, scale: 1, duration: 0.9, ease: "power4.out" }
      );
    }

    // Pause "respiration"
    tl.to({}, { duration: 1.2 });

    // Animation de sortie
    if (content) {
      tl.to(content, {
        opacity: 0,
        y: -80,
        scale: 1.02,
        duration: 0.8,
        ease: "power2.inOut",
      });
    }
  }
});

// --- Effet H1 lettres une par une ---
window.addEventListener("load", () => {
  const h1 = document.querySelector(".start h1");

  // Découpe le texte en spans (une lettre par span)
  const text = h1.textContent;
  h1.textContent = "";

  text.split("").forEach((char) => {
    const span = document.createElement("span");
    span.textContent = char === " " ? "\u00A0" : char; // garde les espaces
    span.style.display = "inline-block";
    h1.appendChild(span);
  });

  const letters = h1.querySelectorAll("span");

  // État de départ : incliné et invisible
  gsap.set(letters, {
    skewX: -15,
    opacity: 0,
    transformOrigin: "left center",
  });

  // Animation lettre par lettre
  gsap.to(letters, {
    skewX: 0,
    opacity: 1,
    duration: 0.8,
    ease: "power3.out",
    stagger: 0.05, // chaque lettre démarre un peu après la précédente
    delay: 0.2,
  });
});

const signature = document.querySelector(".signature");

gsap.fromTo(
  signature,
  {
    opacity: 0,
    y: 12,
  },
  {
    opacity: 1,
    y: 0,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".contact",
      start: "bottom bottom",
      toggleActions: "play none none reverse",
    },
  }
);
